import { ValidationResultItem } from '../typings/common';

import { GridRow } from './domain';
import { AppTracker } from './trackingParametersEditor';

export interface JavaMobileContent {
    age_label: number;
    available_actions: Array<string>;
    content_type: string;
    icon_url: string;
    is_available: boolean;
    is_show_icon: boolean;
    min_os_version: string;
    mobile_content_id: number;
    name: string;
    os_type: string;
    prices: {};
    rating: number;
    rating_votes: number;
    store_content_id: string;
    store_country: string;
    publisherDomain: string;
}

export interface JavaTrackers {
    trackerId: string;
    trackingSystem: string;
    url: string;
}

export interface JavaMobileAppInfo {
    deviceTypeTargeting: Array<string>;
    displayedAttributes: Array<string>;
    domain: string;
    files: Array<string>;
    geoTargeting: Array<number>;
    id: string;
    minOsVersion: string;
    mobileContent: JavaMobileContent;
    mobileContentId: number;
    name: string;
    networkTargeting: Array<string>;
    primaryAction: string;
    store: string;
    storeHref: string;
    trackers: Array<JavaTrackers>;
}

export interface ApiMobileContentInfoResponse {
    name?: string;
    icon_url?: string;
    rating?: number;
    rating_votes?: number;
    available_actions?: Array<string>;
    prices?: Array<{
        [key: string]: {
            price: string;
            price_currency: string;
        };
    }>;
    os_type: string;
    publisherDomain: string;
}

export interface AppsEntry extends GridRow {
    appName: string;
    storeAppName: string;
    storeName: string;
    storeAppId: string;
    iconUrl: string;
    trackName: string | null;
    trackSys: string;
    trackIds: string[];
    trackUrls: string[];
    files: string[];
}

export interface AppData {
    appInfo: AppInfo;
    appSettings: AppSettings;
}

export interface AppFromApiData {
    tracker: AppTracker;
    appInfo: AppInfo;
    appSettings: AppSettings;
}

export interface AppsData {
    data: Array<AppsEntry>;
    allItemsIds: Array<string>;
    total: number;
}

export interface AppInfo {
    name: string;
    iconUrl: string;
    rating: number;
    votes: number;
    price?: number;
    currency?: string;
    appUrl?: string;
    osType?: string;
    errors?: ValidationResultItem[];
    publisherDomain?: string;
}

export interface AppSettings extends AppFlatSettings {
    showInAd: AppShowInAd;
    canEditMobileAppDomain?: boolean;
    canViewMobileAppDomain?: boolean;
}

export interface AppFlatSettings {
    id?: string;
    storeHref?: string;
    name?: string;
    domain?: string;
    propagationMode?: PropagationMode;
}

export enum PropagationMode {
    APPLY_TO_ANY_RELATED_BANNERS_AND_REPLACE_ALL = 'APPLY_TO_ANY_RELATED_BANNERS_AND_REPLACE_ALL',
    APPLY_TO_BANNERS_WITH_SAME_TRACKING_URL_AND_REPLACE_CHANGED = 'APPLY_TO_BANNERS_WITH_SAME_TRACKING_URL_AND_REPLACE_CHANGED',
    DO_NOT_APPLY_TO_BANNERS = 'DO_NOT_APPLY_TO_BANNERS'
}

export interface AppShowInAd {
    price?: boolean;
    rating?: boolean;
    votes?: boolean;
    icon?: boolean;
}

export interface UrlCheckResponse {
    isValid?: boolean;
    errorMessage?: string;
}

export enum MobileAppPageState {
    initial = 'initial',
    loading = 'loading',
    saving = 'saving'
}

export enum MobileAppPageMode {
    create = 'create',
    edit = 'edit',
    view = 'view'
}

export enum MobileSysTypes {
    other = 'OTHER',
    empty = 'EMPTY'
}
